import React, { useState } from 'react';
import styles from './Options.module.scss';
import {
	Button,
	TextField,
	InputAdornment,
	Divider,
	IconButton,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { setAlert } from '../../../../../../redux/alerts/action';
import { connect } from 'react-redux';

const Options = (props) => {
	const { optionArr, setOptionArr, setAlert } = props;

	const handleAddOptionImg = (e, index) => {
		var imgType = e.target.files[0]?.type;
		if (
			imgType === 'image/png' ||
			imgType === 'image/jpeg' ||
			imgType === 'image/jpg' ||
			imgType === 'image/gif'
		) {
			let tempOptionArr = [...optionArr];
			if (tempOptionArr[index].images) {
				tempOptionArr[index].images.push({
					url: URL.createObjectURL(e.target.files[0]),
					file: e.target.files[0],
				});
			} else {
				tempOptionArr[index].images = [
					{
						url: URL.createObjectURL(e.target.files[0]),
						file: e.target.files[0],
					},
				];
			}
			setOptionArr(tempOptionArr);
		} else {
			setAlert('warning', 'Please upload .png or .jpeg or .jpg or .gif');
		}
		e.target.value = null;
	};

	const handleAddOption = () => {
		setOptionArr([...optionArr, { name: '', price: '0', images: [] }]);
	};

	const handleChangeName = (e, index) => {
		let tempOptionArr = [...optionArr];
		tempOptionArr[index] = {
			...tempOptionArr[index],
			name: e.target.value,
		};
		setOptionArr(tempOptionArr);
	};

	const handleChangePrice = (e, index) => {
		let tempOptionArr = [...optionArr];
		tempOptionArr[index] = {
			...tempOptionArr[index],
			price: e.target.value,
		};
		setOptionArr(tempOptionArr);
	};

	const handleDeleteOptionImg = (url, index) => {
		let filteredImageArr = optionArr[index].images.filter(
			(item) => item.url !== url
		);
		let tempOptionArr = [...optionArr];
		tempOptionArr[index] = {
			...tempOptionArr[index],
			images: filteredImageArr,
		};
		setOptionArr(tempOptionArr);
	};

	return (
		<div className={styles.options}>
			{optionArr?.map((option, index) => (
				<div className={styles.option} key={index}>
					{index !== 0 && <Divider className={styles.divider} />}
					<div className={styles.header}>
						<h3 className={styles.title}>Option {index + 1}</h3>
						{index === 0 && (
							<Button
								className={styles.btn}
								onClick={handleAddOption}
							>
								+ Add Option
							</Button>
						)}
					</div>
					<div className={styles.text_field_group}>
						<TextField
							label='name'
							variant='outlined'
							value={option.name}
							className={styles.text_field}
							onChange={(e) => handleChangeName(e, index)}
						/>
						<TextField
							label='price'
							variant='outlined'
							value={option.price}
							className={styles.text_field}
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										+ $
									</InputAdornment>
								),
							}}
							onChange={(e) => handleChangePrice(e, index)}
						/>
					</div>
					<div className={styles.option_img}>
						<div className={styles.header}>
							<h3 className={styles.title}>Images</h3>
							<input
								type='file'
								accept='image/*'
								style={{ display: 'none' }}
								id={`option_img${index}`}
								onChange={(e) => handleAddOptionImg(e, index)}
							/>
							<label htmlFor={`option_img${index}`}>
								<Button
									variant='contained'
									component='span'
									className={styles.option_btn}
								>
									Add Image
								</Button>
							</label>
						</div>
						<div className={styles.body}>
							{option?.images?.map((item) => (
								<div className={styles.preview} key={item.url}>
									<div className={styles.image_section}>
										<img
											src={item.url}
											className={styles.image}
										/>
									</div>
									<div className={styles.name_section}>
										<p className={styles.name}>
											{item?.file?.name}
										</p>
										<IconButton
											size='small'
											onClick={() =>
												handleDeleteOptionImg(
													item.url,
													index
												)
											}
										>
											<ClearIcon fontSize='small' />
										</IconButton>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default connect(null, { setAlert })(Options);
